import _ChevronRightIcon from "@adsk/alloy-react-icon/es/lib/ChevronRightIcon";
import _ChevronLeftIcon from "@adsk/alloy-react-icon/es/lib/ChevronLeftIcon";
import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2;
const _excluded = ["className", "style", "calendar", "calendars", "minDate", "maxDate", "onDateHover", "onDateSelected", "updateActiveMonths", "hasEventForDate", "tooltipContentForDate", "stateHoveredDate", "prevMonth", "nextMonth", "setMonth", "setYear", "startDate", "endDate", "range", "shouldShowSelection"];
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/alloy-react-button';
import { optionalPropType } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import Cell from './Cell';
import YearMonthDropdown from './YearMonthDropdown';
import { getCalendarNavigationProps, getDateVariant, isForwardDisabled, isBackwardDisabled } from '../helpers';
const ARROW_BUTTONS_STYLES = {
  position: 'absolute',
  color: theme.tokens.colors.icon.primary.value,
  '&:disabled': {
    color: theme.tokens.colors.icon.inactive.value
  }
};
const renderLeftIcon = p => /*#__PURE__*/React.createElement(_ChevronLeftIcon, p);
const renderRightIcon = p => /*#__PURE__*/React.createElement(_ChevronRightIcon, p);
const Calendar = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      className,
      style,
      calendar,
      calendars,
      minDate,
      maxDate,
      onDateHover,
      onDateSelected,
      updateActiveMonths,
      hasEventForDate,
      tooltipContentForDate,
      stateHoveredDate,
      prevMonth,
      nextMonth,
      setMonth,
      setYear,
      startDate,
      endDate,
      range,
      shouldShowSelection
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    selectedMonth,
    selectedYear,
    weekdays,
    weeks,
    months,
    years,
    year,
    month,
    index
  } = calendar;
  const {
    hideBack,
    hideForward
  } = getCalendarNavigationProps({
    calendarKey: index,
    totalCalendars: calendars.length
  });
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, rest, {
    ref: ref,
    className: className,
    $_css: [{
      display: 'flex',
      flexDirection: 'column',
      width: "calc(100% / ".concat(calendars.length, ")"),
      padding: "0 ".concat(theme.spacing.M, "px")
    }, style]
  }), /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: theme.spacing.S,
      height: 40,
      position: 'relative'
    }]
  }, !hideBack && /*#__PURE__*/React.createElement(Button, {
    renderIcon: renderLeftIcon,
    variant: Button.VARIANTS.TERTIARY,
    style: [_objectSpread(_objectSpread({}, ARROW_BUTTONS_STYLES), {}, {
      left: 0
    })],
    onClick: prevMonth,
    disabled: isBackwardDisabled({
      calendars,
      minDate
    }),
    "data-testid": "DatePickerArrowBack"
  }), /*#__PURE__*/React.createElement(_StyledDiv3, null, /*#__PURE__*/React.createElement(YearMonthDropdown, {
    items: months,
    selectedItem: selectedMonth,
    onSelectedItemChange: _ref2 => {
      let {
        selectedItem
      } = _ref2;
      if (selectedItem) {
        setMonth(calendar.index, selectedItem.key);
      }
    },
    disabled: !months || months.length <= 1,
    "data-testid": "DatePickerCalendar-".concat(calendar.index, "-month")
  }, selectedMonth === null || selectedMonth === void 0 ? void 0 : selectedMonth.label), /*#__PURE__*/React.createElement(YearMonthDropdown, {
    items: years,
    selectedItem: selectedYear,
    style: {
      marginLeft: theme.spacing.M
    },
    onSelectedItemChange: _ref3 => {
      let {
        selectedItem
      } = _ref3;
      if (selectedItem) {
        setYear(calendar.index, selectedItem.key);
      }
    },
    disabled: !years || years.length <= 1,
    "data-testid": "DatePickerCalendar-".concat(calendar.index, "-year")
  }, selectedYear === null || selectedYear === void 0 ? void 0 : selectedYear.label)), !hideForward && /*#__PURE__*/React.createElement(Button, {
    renderIcon: renderRightIcon,
    variant: Button.VARIANTS.TERTIARY,
    style: [_objectSpread(_objectSpread({}, ARROW_BUTTONS_STYLES), {}, {
      right: 0
    })],
    onClick: nextMonth,
    disabled: isForwardDisabled({
      calendars,
      maxDate
    }),
    "data-testid": "DatePickerArrowForward"
  })), /*#__PURE__*/React.createElement(_StyledDiv4, {
    key: "".concat(month).concat(year),
    $_css3: [{
      display: 'flex',
      flexWrap: 'wrap'
    }]
  }, useMemo(() => weekdays.map(weekday => /*#__PURE__*/React.createElement(Cell, {
    key: "".concat(month, "/").concat(year, "-").concat(weekday),
    variant: Cell.VARIANTS.SPACER
  }, weekday)), [weekdays, month, year]), useMemo(() => weeks.map((week, weekIndex) => week.map((dateObj, dayIndex) => {
    const key = "".concat(month, "/").concat(year, "-").concat(dayIndex, "/").concat(weekIndex);
    let selectedDates = [startDate, endDate];
    if (!dateObj) {
      return /*#__PURE__*/React.createElement(Cell, {
        key: key,
        variant: Cell.VARIANTS.SPACER
      });
    }
    if (startDate && endDate && startDate > endDate) {
      selectedDates = [endDate, startDate];
    }
    const currentVariant = getDateVariant({
      range,
      selectedDates,
      date: dateObj.date,
      stateHoveredDate,
      isOutside: dateObj.isOutside,
      shouldShowSelection
    });
    return /*#__PURE__*/React.createElement(Cell, {
      key: key,
      "data-testid": "data-cell-".concat(currentVariant),
      today: dateObj.today,
      selected: dateObj.selected && shouldShowSelection,
      disabled: !dateObj.selectable,
      hasEvent: !!(hasEventForDate !== null && hasEventForDate !== void 0 && hasEventForDate(_objectSpread({}, dateObj))),
      tooltipContent: tooltipContentForDate ? tooltipContentForDate(_objectSpread({}, dateObj)) : null,
      onClick: () => onDateSelected(dateObj, updateActiveMonths),
      variant: currentVariant,
      onMouseEnter: () => onDateHover === null || onDateHover === void 0 ? void 0 : onDateHover(dateObj.date)
    }, dateObj.date.getDate());
  })), [hasEventForDate, onDateSelected, tooltipContentForDate, updateActiveMonths, weeks, onDateHover, endDate, month, range, startDate, stateHoveredDate, year, shouldShowSelection])));
});
Calendar.displayName = 'Calendar';
const monthPropType = PropTypes.any;
Calendar.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Current calendar data */
  calendar: PropTypes.shape({
    index: PropTypes.number.isRequired,
    firstDayOfMonth: PropTypes.instanceOf(Date).isRequired,
    lastDayOfMonth: PropTypes.instanceOf(Date).isRequired,
    month: PropTypes.number.isRequired,
    year: PropTypes.number.isRequired,
    weeks: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.any.isRequired).isRequired).isRequired,
    months: PropTypes.arrayOf(monthPropType.isRequired).isRequired,
    weekdays: PropTypes.arrayOf(PropTypes.any).isRequired,
    years: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.number.isRequired,
      label: PropTypes.number.isRequired
    }).isRequired).isRequired,
    selectedMonth: optionalPropType(monthPropType),
    selectedYear: optionalPropType(PropTypes.shape({
      key: PropTypes.number.isRequired,
      label: PropTypes.number.isRequired
    }))
  }).isRequired,
  /** all of the calendars */
  calendars: PropTypes.array.isRequired,
  /** on Date hover callback */
  onDateHover: PropTypes.func,
  /** current date hovered */
  stateHoveredDate: PropTypes.instanceOf(Date),
  /** Allow selection of dates after minDate, overrides `disablePastDates` */
  minDate: PropTypes.instanceOf(Date),
  /** Allow selection of dates before maxDate, overrides `disableFutureDates` */
  maxDate: PropTypes.instanceOf(Date),
  /** Flag whether the date picker is for a date range of a single value */
  range: PropTypes.bool,
  onDateSelected: PropTypes.func.isRequired,
  updateActiveMonths: PropTypes.func.isRequired,
  hasEventForDate: PropTypes.func,
  tooltipContentForDate: PropTypes.func,
  prevMonth: PropTypes.func.isRequired,
  nextMonth: PropTypes.func.isRequired,
  setMonth: PropTypes.func.isRequired,
  setYear: PropTypes.func.isRequired,
  /** A selected start date for a calendar with range data (should be used with range=true) */
  startDate: PropTypes.instanceOf(Date),
  /** A selected end date for a calendar with range data (should be used with range=true) */
  endDate: PropTypes.instanceOf(Date)
};
export default Calendar;
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), p => p.$_css);
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), p => p.$_css2);
var _StyledDiv3 = _styled3("div")({
  display: 'flex'
});
var _StyledDiv4 = _styled4("div").withConfig({
  displayName: "Calendar___StyledDiv4",
  componentId: "sc-10idd2m-0"
})(["", ""], p => p.$_css3);
//# sourceMappingURL=Calendar.js.map